import { render, staticRenderFns } from "./Universal.vue?vue&type=template&id=742b9fb9&"
import script from "./Universal.vue?vue&type=script&lang=ts&"
export * from "./Universal.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports